import { gql } from '@apollo/client';

const listMarkets = gql`
  query ListMarkets {
    webMarket {
      listMarkets(input: { identifiers: [] }) {
        market {
          id
          marketData {
            marketIdentifier
            active
            displayName
          }
        }
      }
    }
  }
`;

export default listMarkets;
